import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, message, Button, Result, Tag, Empty, Avatar } from "antd-v4";
import logoLight from "../../../assets/images/logo/logo-light.png";
import Loader from "../../components/loader";
import { FaCircle } from "react-icons/fa";
import { getTagColor } from "../../../utils/Utils";
import { getInterestLevel } from '@leedpulse-monorepo/utils';
import leedpulse from "../../../configs/leedpulse";
import { PhoneOutlined } from "@ant-design/icons";

export default function ConversationResume() {

  const { idcontact } = useParams();

  const [contact, setContact] = useState(null);
  const [error, setError] = useState(null);
  const [messages, setMessages] = useState(null);


  // Query contact
  useEffect(() => {
    if (idcontact) {
      fetch(leedpulse.route_url + '/api/v1/contact/' + idcontact + '/conversation/resume')
        .then((res) => res.json())
        .then((resContact) => {
          if (resContact.error) {
            message.error(resContact.error);
          } else {
            if (resContact.success) {
              setContact(resContact.data);
              setMessages(resContact.data.messages || []);
            } else {
              setError("Contact introuvable");
            }
          }
        }).catch((err) => {
          console.error("Erreur lors de la récupération du contact:", err);
          setError("Erreur lors de la récupération du contact");
        });
    } else {
      // Synchro avec une source distante : l'etat vient d'un appel reseau, pas du
      // rendu. C'est l'usage d'un effet que la regle autorise ("synchronizing with an
      // external system") ; le setState synchrone est le reset qui precede l'appel.
      // eslint-disable-next-line react/set-state-in-effect
      setError("Contact introuvable");
    }
  }, [idcontact]);

  const MessageBubble = ({ message, isUser, senderName }) => {

    return (
      <div
        style={{
          display: "flex",
          justifyContent: isUser ? "flex-start" : "flex-end",
          marginBottom: "8px",
          width: "100%",
          alignItems: "flex-start"
        }}
      >
        {isUser && (
          <Avatar
            size={32}
            style={{
              backgroundColor: "#6737FF",
              color: "#FFFFFF",
              marginRight: "8px",
              flexShrink: 0,
              fontWeight: "300",
              fontSize: "15px"
            }}
          >
            {senderName ? senderName.charAt(0).toUpperCase() : "P"}
          </Avatar>
        )}
        <div
          style={{
            maxWidth: "70%",
            padding: "8px 12px",
            borderRadius: "18px",
            backgroundColor: isUser ? "#E5E5EA" : "#6737FF",
            color: isUser ? "#000" : "#FFF",
            fontSize: "14px",
            lineHeight: "1.4",
            wordWrap: "break-word"
          }}
        >
          <div style={{ fontWeight: "600", fontSize: "12px", marginBottom: "4px", opacity: 0.8 }}>
            {senderName}
          </div>
          <div>{message}</div>
        </div>
      </div>
    );
  };

  return (
    <Row align={'middle'} justify="center" className="hp-authentication-page">
      <Col lg={12} span={24} className="hp-py-sm-0 hp-py-md-64">
        <Row className="hp-h-100" justify="center">
          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48"
          >
            <Col align="center">
              <img
                src={logoLight}
                alt="Logo LeedPulse"
                style={{ width: "334px" }}
              />
            </Col>
            {contact && contact.qualification_ai && (
              <Col>
                <h2 style={{ textAlign: "center" }}>{contact.contact?.firstname + " " + contact.contact?.lastname}</h2>
                <div style={{ textAlign: "center" }}>
                  <div style={{ display: "flex", justifyContent: "center", margin: "12px 0" }}>
                    <Tag className='hp-d-flex-full-center' icon={<FaCircle size={8} />} color={getTagColor(getInterestLevel(contact?.qualification_ai?.qualification))}>
                      <span className='hp-ml-12'> {getInterestLevel(contact?.qualification_ai?.qualification)}</span>
                    </Tag>
                  </div>
                  <span className="hp-text-color-black-80 hp-text-color-dark-20">
                    {contact.qualification_ai?.summary}
                  </span>
                  <br />
                  <a href={"tel:" + contact?.contact?.phone}>
                    <Button type="primary" className="hp-mt-24">
                      <PhoneOutlined /> Appeler le prospect
                    </Button>
                  </a>
                </div>

                <div
                  style={{
                    width: "60%",
                    height: "1px",
                    backgroundColor: "#E0E0E0",
                    margin: "24px auto"
                  }}
                />


                <h3 className="hp-mt-16">Conversation</h3>

                <div
                  className="hp-mt-16"
                  style={{
                    width: "100%",
                    padding: "16px"
                  }}
                >
                  {messages && messages.length > 0 ? (
                    messages.map((message) => {
                      let senderName = "Anonyme";

                      if (message.role === "assistant" && message.manualsending === true) {
                        senderName = "Humain";
                      } else if (message.role === "assistant" && message.manualsending !== true) {
                        senderName = "IA";
                      } else if (message.role === "user") {
                        senderName = contact?.contact?.firstname || "Prospect";
                      }

                      return (
                        <MessageBubble
                          key={message.id}
                          message={message.message}
                          senderName={senderName}
                          isUser={message.role === "user"}
                        />
                      );
                    })
                  ) : messages && messages.length === 0 ? (
                    <Empty
                      description={<span className="hp-text-color-dark-30">Aucun message</span>}
                    />
                  ) : (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                      <Loader />
                    </div>
                  )}
                </div>
              </Col>
            )}
            {contact == null && error == null && (
              <Loader />
            )}
            {error && (
              <Result
                status="error"
                title="Oups"
                subTitle={error}
              />
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
